<!-- *ngIf prevents user from focusing any tabbable elements if slideout isn't visible -->
@if (!_hasFinishedHiding) {
    <ng-content></ng-content>
}
